// Text.js - Contains text constants and translations for the application

export const Text = {
  // Form related text
  FORM_BUILDER: 'Form Builder',
  FORM_TITLE: 'Form Title',
  FORM_DESCRIPTION: 'Form Description',
  FIELD_LABEL: 'Field Label',
  FIELD_TYPE: 'Field Type',
  REQUIRED_FIELD: 'Required Field',
  PLACEHOLDER_TEXT: 'Placeholder Text',
  
  // Button text
  ADD_FIELD: 'Add Field',
  SAVE_FORM: 'Save Form',
  PREVIEW_FORM: 'Preview Form',
  EDIT_FIELD: 'Edit Field',
  DELETE_FIELD: 'Delete Field',
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  
  // Application related text
  APPLICATIONS: 'Applications',
  APPLICATION_FORM: 'Application Form',
  VIEW_APPLICATION: 'View Application',
  NEW_APPLICATION: 'New Application',
  EDIT_APPLICATION: 'Edit Application',
  DELETE_APPLICATION: 'Delete Application',
  
  // General UI text
  LOADING: 'Loading...',
  ERROR: 'Error',
  SUCCESS: 'Success',
  WARNING: 'Warning',
  CONFIRM: 'Confirm',
  BACK: 'Back',
  NEXT: 'Next',
  FINISH: 'Finish',
  
  // Status text
  PUBLISHED: 'Published',
  UNPUBLISHED: 'Unpublished',
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
    // Messages
  FORM_SAVED_SUCCESS: 'Form saved successfully',
  FORM_DELETED_SUCCESS: 'Form deleted successfully',
  APPLICATION_SUBMITTED_SUCCESS: 'Application submitted successfully',
  GENERIC_ERROR: 'An error occurred. Please try again.',
};

// Export individual constants for compatibility
export const TEXT_CONNECTION_ERROR = 'Connection error. Please check your internet connection and try again.';
export const TEXT_ARCHIVE = 'Archive';

export default Text;
